import { useState, useCallback, useRef, ChangeEvent } from 'react';
import { nameAndLifetimeOf } from './Utils';
import { Database, Individual, IndividualCallback } from './Data';
import styles from './Search.module.css';

interface SearchProps {
    database: Database;
    showDetails: IndividualCallback;
}

export function Search({ database, showDetails }: SearchProps) {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState<Individual[] | undefined>(undefined);
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const handleQueryChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        console.log('handleQueryChange');
        const newQuery = event.currentTarget.value;
        setQuery(newQuery);
        setResults(undefined);

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            setResults(database.searchIndividuals(newQuery));
        }, 250);
    }, [database]);

    const searchResults = () => {
        if (results === undefined) {
            return null;
        }
        if (results.length === 0) {
            return <div className={styles.noResults}>No results found.</div>;
        }

        const resultList = results.map((i) => (
            <li key={'individual_search' + i.id}>
                <button
                    className={styles.resultButton}
                    onClick={() => showDetails(i.id)}
                >
                    {nameAndLifetimeOf(i)}
                </button>
            </li>
        ));
        return (
            <div className={styles.results}>
                <ul className={styles.resultsList}>{resultList}</ul>
            </div>
        );
    };

    return (
        <div className={styles.container}>
            <label htmlFor="search-box" className={styles.label}>
                Search Individuals:
            </label>
            <input
                id="search-box"
                name="query"
                type="text"
                className={styles.input}
                placeholder="Enter name to search for"
                value={query}
                onChange={handleQueryChange}
            />
            {searchResults()}
        </div>
    );
}
